import { render, staticRenderFns } from "./ControlSideBar.vue?vue&type=template&id=9b25c666&scoped=true&"
import script from "./ControlSideBar.vue?vue&type=script&lang=js&"
export * from "./ControlSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b25c666",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b25c666')) {
      api.createRecord('9b25c666', component.options)
    } else {
      api.reload('9b25c666', component.options)
    }
    module.hot.accept("./ControlSideBar.vue?vue&type=template&id=9b25c666&scoped=true&", function () {
      api.rerender('9b25c666', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/control-sidebar/ControlSideBar.vue"
export default component.exports